import { Typography, makeStyles } from '@material-ui/core';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import SGSInputCurrency from 'components/SGSCurrency';
import moment from 'moment';
import { ISalairePeriod } from '.';

type TableSalaireProps = {
    salaries: ISalairePeriod[];
    store: any;
    setValue: Function;
    ficheParametrage: any; // TODO :: create schema type
};

// TODO :: vérifier si ce tableau est encore utilisé

export const TableSalairePeriod: React.FC<TableSalaireProps> = ({ salaries, store, setValue, ficheParametrage }) => {
    console.log(store, setValue); // TODO :: remove ?
    const classes = useStyles();

    const displaySalairesBruts = (ficheParametrage?.salairesBruts && ficheParametrage.salairesBruts === '1') ?? true;
    const displayPrimesGratificationsBrutes = (ficheParametrage?.primesEtGratificationsBrutes && ficheParametrage.primesEtGratificationsBrutes === '1') ?? true;
    const displaySalaireNets = (ficheParametrage?.salairesNets && ficheParametrage.salairesNets === '1') ?? true;
    const displayPrimesNettes = (ficheParametrage?.primesetGratificationsNettes && ficheParametrage.primesetGratificationsNettes === '1') ?? true;

    return (
        <>
            <StyledTableContainer>
                <Table size="small">
                    <TableHead>
                        <StyledTableRow1>
                            <StyledTableRow1Header colSpan={5} align="center">
                                <Typography>SALAIRE DE BASE ET ACCESSOIRES DU SALAIRE</Typography>
                            </StyledTableRow1Header>
                        </StyledTableRow1>
                        <TableRow>
                            <StyledTableRow2Header />
                            {displaySalairesBruts && (
                                <StyledTableRow2Header>
                                    <Typography className={classes.txtGreen}>Salaires bruts (à l'exclusion des primes et gratifications)</Typography>
                                </StyledTableRow2Header>
                            )}
                            {displayPrimesGratificationsBrutes && (
                                <StyledTableRow2Header>
                                    <Typography className={classes.txtGreen}>Primes et gratifications brutes versées pendant la même période</Typography>
                                </StyledTableRow2Header>
                            )}
                            {displaySalaireNets && (
                                <StyledTableRow2Header>
                                    <Typography className={classes.txtGreen}>Salaires nets imposables (à l'exclusion des primes et gratifications)</Typography>
                                </StyledTableRow2Header>
                            )}
                            {displayPrimesNettes && (
                                <StyledTableRow2Header>
                                    <Typography className={classes.txtGreen}>Primes et gratifications nettes versées pendant la même période</Typography>
                                </StyledTableRow2Header>
                            )}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {salaries.map((item, index) => (
                            <StyleTableRow key={item.id}>
                                <StyledTableCell>
                                    <Typography noWrap className={classes.txtPeriod}>
                                        {moment(salaries[index].startDate).format('DD/MM/YYYY')} - {moment(salaries[index].endDate).format('DD/MM/YYYY')}
                                    </Typography>
                                </StyledTableCell>
                                {displaySalairesBruts && (
                                    <StyledTableCell>
                                        <SGSInputCurrency name={`salaryReferences.salaries.${index}.salaryBrut`} />
                                    </StyledTableCell>
                                )}
                                {displayPrimesGratificationsBrutes && (
                                    <StyledTableCell>
                                        <SGSInputCurrency name={`salaryReferences.salaries.${index}.primesBrut`} />
                                    </StyledTableCell>
                                )}
                                {displaySalaireNets && (
                                    <StyledTableCell>
                                        <SGSInputCurrency name={`salaryReferences.salaries.${index}.salaryNet`} />
                                    </StyledTableCell>
                                )}
                                {displayPrimesNettes && (
                                    <StyledTableCell>
                                        <SGSInputCurrency name={`salaryReferences.salaries.${index}.primesNet`} />
                                    </StyledTableCell>
                                )}
                            </StyleTableRow>
                        ))}
                    </TableBody>
                </Table>
            </StyledTableContainer>
        </>
    );
};

const useStyles = makeStyles(() => ({
    header: {
        height: '54px',
    },
    dtEmis: {
        color: '#fff',
        fontSize: '0.8rem',
        fontFamily: 'Open Sans',
        fontStyle: 'normal',
        height: '100%',
        width: '170px',
    },

    txtGreen: {
        color: '#2574A9',
        fontSize: '0.83rem ',
        fontFamily: 'Open Sans ',
        fontStyle: 'normal ',
        fontWeight: 700,
    },
    txtPeriod: {
        color: '#2574A9',
        fontSize: '1rem ',
        fontFamily: 'Open Sans ',
        fontStyle: 'normal ',
        fontWeight: 700,
        paddingTop: '16px',
    },
}));

const StyledTableContainer = styled(TableContainer)(() => ({
    boxShadow: 'none',
    border: 'none',
    borderTop: 'none',
}));

const StyledTableRow1 = styled(TableRow)(() => ({
    backgroundColor: '#3399DB ',
    borderBottom: 'none',
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    border: '1px solid #3399DB',
}));

const StyledTableRow1Header = styled(TableCell)(() => ({
    color: '#FFF',
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontSize: '0.85rem',
    textAlign: 'center',
    paddingTop: '5px',
    height: '54px',
    paddingBottom: '3px',
}));

const StyledTableRow2Header = styled(TableCell)(() => ({
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontSize: '0.85rem',
    textAlign: 'center',
    borderLeft: '1px solid #cdcdcd',
    borderRight: '1px solid #cdcdcd',
    borderBottom: '1px solid #cdcdcd',
    borderTop: 'none',
    background: '#F5F5F5',
}));

const StyledTableCell = styled(TableCell)(() => ({
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontSize: '0.85rem',
    textAlign: 'center',
    verticalAlign: 'top',
    borderLeft: '1px solid #cdcdcd',
    borderRight: '1px solid #cdcdcd',
    borderBottom: 'none',
    borderTop: 'none',
    background: '#FFF',
}));

const StyleTableRow = styled(TableRow)(() => ({
    backgroundColor: '#3399DB ',
    borderBottom: 'none',
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    border: '1px solid #cdcdcd',
}));
